import Styles from './CreateSelect.module.scss'
import { Modal } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'
import { Automated } from 'blaze-ui/icons/40'
import cx from 'classnames'
import { BlazeNewButton } from 'blaze-components/WorkspaceDashboardSidebar/components/NavMenu/Buttons/BlazeNewButton'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import Lock2 from 'blaze-ui/icons/24/Lock2'
import { CreditsRemainingCta } from 'components/Settings/TieredBilling/components/AutopilotDetails/components/CreditsRemainingCta/CreditsRemainingCta'

interface CreateSelectProps {
  onNext: () => void
  onWizardsBack: () => void
}

export const CreateSelect = ({ onNext, onWizardsBack }: CreateSelectProps) => {
  const workspace = useCurrentWorkspace()

  return (
    <>
      <Modal.Header title="Create Content" actions={<CreditsRemainingCta />} />
      <Modal.Content withoutFooter>
        <div className={Styles.container}>
          <div className={Styles.createContentCard}>
            <Automated size={60} />
            <div className={Styles.content}>
              <div className={Styles.labels}>
                <Heading level={4}>Automatic Generation</Heading>
                <Text variant="placeholder" color="var(--dark-60)">
                  Let Blaze create & design multiple pieces of content
                </Text>
              </div>
              <Button variant="primary" size="lg" onPress={onNext} endIcon={ArrowRight} aria-label="Create Automatic">
                Create
              </Button>
            </div>
          </div>
          <div className={cx(Styles.createContentCard, Styles.manual)}>
            <div className={Styles.content}>
              <div className={Styles.labels}>
                <Heading level={4}>Manual Wizards</Heading>
                <Text variant="placeholder" color="var(--dark-60)">
                  Use Blaze wizard to generate a single piece of content.
                </Text>
              </div>
              <BlazeNewButton
                label="Create"
                size="lg"
                variant="secondary"
                endIcon={workspace?.is_ap_freemium ? Lock2 : ArrowRight}
                withShimmer={false}
                onBack={onWizardsBack}
                ariaLabel="Create Manual"
              />
            </div>
          </div>
        </div>
      </Modal.Content>
    </>
  )
}
